// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2OHBp","dragIcon":"Choice_dragIcon__1QnQe","left":"Choice_left__2eYLH","input":"Choice_input__3aG9L"};